export const OVERLAY_HTML_ELEMENT_ID = 'overlay-alert-component';
export const BANNER_HTML_ELEMENT_ID = 'banner-alert-component';
